import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { RecruiterScreeningCallContactDetailsForm } from "./RecruiterScreeningCallContactDetailsForm";

export function RecruiterScreeningCallMeNowContactContent() {
  return (
    <Stack spacing={8}>
      <Stack spacing={6}>
        <Text variant="h3" align="center">
          Confirm your call
        </Text>
        <Text variant="body1" align="center">
          We&apos;ll call you within the next 15 minutes!
        </Text>
      </Stack>

      {/* Contact details form */}
      <RecruiterScreeningCallContactDetailsForm />
    </Stack>
  );
}
